import type {
  SopMarkupAnnotation,
  SopImageMarkupType,
} from '../../../request/sop-synthesizer/sopSynthesizer.api.ts';

export type {
  SopMarkupAnnotation,
  SopMarkupType,
  SopImageMarkupType,
  SopTextMarkupType,
} from '../../../request/sop-synthesizer/sopSynthesizer.api.ts';

const IMAGE_TYPES = new Set<string>([
  'image_rect',
  'image_ellipse',
  'image_arrow',
  'image_pen',
  'image_text',
  'image_callout',
  'image_pin',
]);

export function isImageMarkupType(type: string): type is SopImageMarkupType {
  return IMAGE_TYPES.has(type);
}

export function isTextMarkupType(type: string): boolean {
  return type === 'highlight' || type === 'comment';
}

export function parseSopMarkup(raw: unknown): SopMarkupAnnotation[] {
  if (!Array.isArray(raw)) return [];
  return raw.filter(
    (a) => a && typeof a === 'object' && typeof (a as { id?: string }).id === 'string',
  ) as SopMarkupAnnotation[];
}

export function canEditSopMarkup(_status: string): boolean {
  return true;
}

export const SOP_IMAGE_MARKUP_COLORS = [
  '#ef4444',
  '#f59e0b',
  '#eab308',
  '#22c55e',
  '#3b82f6',
  '#a855f7',
  '#111827',
] as const;
